function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_2",
  "data-name": "Rectangle 2",
  width: 4.047,
  height: 12.024,
  transform: "translate(0.224 5.787)",
  fill: "#3352cb"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_3",
  "data-name": "Path 3",
  d: "M1059.792,49.6a2.133,2.133,0,0,0-2.3,1.95c0,.043-.006.086-.007.13a2.035,2.035,0,0,0,1.98,2.088c.071,0,.144,0,.215-.006a2.136,2.136,0,0,0,2.3-1.955c0-.041.006-.083.007-.126a2.1,2.1,0,0,0-2.117-2.083Z",
  transform: "translate(-1057.481 -49.591)",
  fill: "#3352cb"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Path_4",
  "data-name": "Path 4",
  d: "M1071.44,55.128a3.906,3.906,0,0,0-3.584,1.964V55.358h-3.932V67.382h3.931V60.676a3.218,3.218,0,0,1,.116-1.04,2.179,2.179,0,0,1,2.082-1.506c1.388,0,2.081,1.156,2.081,2.66v6.474h4.047V60.326C1076.064,56.748,1074.1,55.129,1071.44,55.128Z",
  transform: "translate(-1057.454 -49.567)",
  fill: "#3352cb"
});

var SvgLinkedinIcon = function SvgLinkedinIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Group_5",
    "data-name": "Group 5",
    width: 18.727,
    height: 17.815,
    viewBox: "0 0 18.727 17.815",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLinkedinIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/linkedin-icon.0f997669.svg";
export { ForwardRef as ReactComponent };